import {SxProps, Theme} from '@mui/material'

export const getFormPrimaryButtonSx: SxProps<Theme> = (theme) => ({boxShadow: theme.shadows[4]})
